import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/join/page.tsx");
